module.exports = __webpack_public_path__ + "static/media/activity-pencil.2aa5454d.svg";